import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";
import { PerformanceState } from "./state";

const defaultState: PerformanceState = {
  performances: [
    {
      id: 1,
      game_version: "2.2",
      task_group_index: 1,
      id_test: 1,
      id_label: "1",
      period: "1",
      remark: "1",
      avg_fps: "1",
      max_pss: "1",
      max_mono_used: "",
      max_mono_total: "",
      avg_cpu: "",
      fps_lt_10_pcnt: "",
      fps_lt_18_pcnt: "",
      fps_lt_25_pcnt: "",
      fps_lt_40_pcnt: "",
      cpu_lt_60_pcnt: "",
      cpu_lt_80_pcnt: "",
      dps: "",
      avg_dc: "",
      max_dc: "",
      max_triangle: "",
      duration: "",
      avg_flow: "",
      max_swap: "",
      max_vss: "",
      max_swap_add_pss: "",
      process_up_flow: "",
      process_down_flow: "",
      logic_up_flow: "",
      logic_down_flow: "",
      lag_cnt: 0,
      single_peak_lag_cnt: 0,
      multiple_peak_lag_cnt: 0,
      continue_low_lag_cnt: 0,
      lag_pcnt: 0,
      lag_freq: 0,
      id_row_start: 0,
      id_row_end: 0,
      id_frame_start: 1,
      id_frame_end: 1,
      avg_cpu_total: "",
      gc_cnt: 1,
      gc_freq: 1,
      timestamp: "2021-07-09T10:52:57",
      url:
        "http://runmax.oa.com/nav/runmax/client-perf-test-report?id_test=29288",
      // task_record_id: 1,
      project: 2,
      device_id: 1,
      // script_id: 1,
      scene_id: 1,
    },
  ],
  date_versions: { game_versions: [] },
  all_performances: [],
  performance_table_fields: {},
  performance_page_list: {
    count: 0,
    next: "",
    previous: null,
    results: [],
  },
  setPerformancePageListSummary: {
    count: 0,
    next: "",
    previous: null,
    results: [],
  },
  deep_performance_page_list: {
    count: 0,
    next: "",
    previous: null,
    results: [],
  },
  performance_select_options: {
    date_list:[],
    scene_list: [],
    device_list: [],
    game_versions: [],
  },
  performance_custom_version:{},
  deep_performance_select_options: {
    scene_list: [],
    device_list: [],
    game_versions: [],
  },
  deep_performance_select_options_old: {
    scene_list: [],
    device_list: [],
    game_versions: [],
  },
  deep_performance_select_options_last: {
    scene_list: [],
    device_list: [],
    game_versions: [],
  },
  label_info: [],
  label_info_laebl:{},
  perf_info: [],
  test_info: [],
  cperf_second_data: {
    markAreaDataSecond: [],
    markAreaDataFrame: [],
    fps: {},
    frame_time: {},
    process_cpu_pcnt: {},
    cpu_freq: {},
    pss: {},
    vss: {},
    flow: {},
    mono: {},
    drawcall: {},
    triangle: {},
    temp: {},
    electric: {},
    result: {},
  },
  report_list: {
    next: "",
    count: 0,
    previous: "",
    results: [],
  },
  new_report: {
    id: 0,
    report_name: "",
    new_version: "",
    old_version: "",
    test_info: "",
    risk: null,
    create_date: "",
    settings: "",
    creator: "",
  },
  new_smg_report:{},
  new_report_list: {},
  live_report_list: {},
  perf_report: {},
  weapon_report:{},
  nzm_report: {},
  perf_report_gpu: {},
  live_report: {},
  perf_report_id_test: {},
  stress_perf_report: {},
  label_report: {},
  aov_copy_perf_to_report: {},
  perf_dashboard: {
    report_num: 0,
    test_device_num: 0,
    test_scene_num: 0,
    line_chart: [],
    pipeline_download_num: 0,
    series: [],
    x_axis: [],
    device_names: [],
    timelines: [],
    cpu_trend: {},
  },
  performance_analysis: {
    current_version_data: {
      avg_fps: "",
      lag_pcnt: 1,
      max_pss: "",
      max_mono_used: "",
      avg_cpu: 1,
      gc_cnt: 1,
      max_triangle: "",
      max_dc: "",
      cpu_power: 1,
      avg_cpu_usage: "",
      max_cpu_usage: "",
    },
    last_version_data: {
      avg_fps: "",
      lag_pcnt: 1,
      max_pss: "",
      max_mono_used: "",
      avg_cpu: 1,
      gc_cnt: 1,
      max_triangle: "",
      max_dc: "",
      cpu_power: 1,
      avg_cpu_usage: "",
      max_cpu_usage: "",
    },
    nearby_seven_data: [
      {
        game_version: "",
        url: "",
      },
    ],
    version_list: [],
    custom_index: [],
  },
  performance_aov_trend: [
    {
      date_list: [],
      performance_briefs: [
        {
          avg_fps: "",
          lag_pcnt: 1,
          max_pss: "",
          max_mono_used: "",
          avg_cpu: 1,
          gc_cnt: 1,
          max_triangle: "",
          max_dc: "",
          device_id: 16,
        },
      ],
    },
  ],
  performance_aov_email: {
    project: 1,
    // trend_device:1,
    interval: 2,
    task_record_id: 1,
    file_list: {},
  },
  aov_performances: [],
  task_record_query: [],
  task_record_devices: [],
  aov_performance_copy: [],
  last_record: 81,
  recent_taskrecord: [],
  upload_performance: {
    b_auto_collect: false,
    project: 1,
    is_valid: true,
    UUID: "",
    remark: "",
    scene_id: 1,
    file: "",
    task_record_id: "",
    task_group_index: "",
    is_dfm_ios: false,
  },
  upload_top_performance: {
    project:1 ,
    project_name: "",
    url: "",
    file: ""
  },
  add_bug: {
    project:1 ,
   title:'',
  description:'',
  current_owner:'',
  originphase:'',
  severity:'',
  version_report:''
  },
  upload_top_performance_load:[],
  top_templates:[],
  top_baselines:[],
  top_templates_data:{},
  top_baselines_data:{},
  codm_report: {
    test_info: {
      cur_version: "",
      test_time: "",
      month: "",
      old_version: "",
      old_month: "",
      type: 0,
    },
    memory_data: {},
    memory_analysis: {},
    trend_data: {
      x_axis: [],
      scene_list: [],
      mono: {},
      engine: {},
    },
    core_data: [],
    link: "",
    compare_link: "",
  },
  codm_reports: [],
  top_reports: [],
  smoke_reports: [],
  protocol_list:[],
  login_smoke_reports:[],
  top_report_detail: {
    id: 0,
    report_name: "",
    create_date: "",
    creator: "",
  },
  top_report: {
    risk: "低风险",
    base_info: {
      user_percent: 0,
      test_model_num: 0,
      benchmark: "",
      scene_list: [],
      platform: "安卓", // 平台
      pass_model_num: 0,
      no_pass_model_num: 0,
      pass_rate: "100%", // 通过率.
    },
    project_name: "TOP机型测试",
    project_icon: "",
    version: "",
    problem_model_list: [],
    trend: {
      levels: [],
      versions: [],
      series: [],
    },
  },
  top_report_table: [
    {
      avg_cpu: "",
      avg_fps: "",
      device_id: { id: 0, model: { model: "", name: "", type: 0 }, level: 0 },
      game_version: "",
      id: 0,
      max_pss: "",
      project: { id: 0, pkg_name: "", project_name: "" },
      scene_id: { id: 0, chinese: "" },
      task_record_id: { id: 0, create_user: "" },
      tester: null,
      timestamp: "",
      num: 0,
    },
  ],
  top_report_table_list: {
    date_list: [],
    project_list: [],
    user_list: [],
  },
  top_report_table_generate: {},
  xhook_report: {
    data: {
      test_info: {
        cur_version: "",
        test_time: "",
        month: "",
        old_version: "",
        old_month: "",
        type: 0,
      },
      memory_data: {},
      memory_analysis: {},
      total_trend: {
        x_axis: [],
        scene_list: [],
        total: {},
      },
      memory_trend: {
        x_axis: [],
        memory: {},
      },
      core_data: [],
      link: "",
      compare_link: "",
      previous_version: "",
    },
  },
  Wado_report: {},
  Skin_report: {},
  Skin_report_option:{},
  Skin_report_list:{},
  Skin_report_option_old:{},
  Skin_report_whole:{},
  Skin_report_data:{},
  Skin_report_compare_data:{},
  Skin_report_inside: {},
  smg_report:{},
  Skin_report_table:{},
  arrange:{},
  xhook_report_list: [],
  Smoke_Report: {},
  protocol_report:{},
  Login_Smoke_Report:{},
  Log_download: {},
  Performance_version: {},
  deep_performance_details: {},
  case_monitor_list: [],
  case_monito:{},
  deep_performance_stack: {},
  instantiation: {},
  instantiations: {},
  change_fPS_lte: {},
  change_fPS_gte: {},
  player_id: {},
  dc: {},
  dc_report: [],
  deep_scene: [],
  deep_scene_old: [],
  deep_find: [],
  task_list: [],
  nzm_memory_stack_all: [],
  deep_scene_vedio: [],
  deep_scene_old_vedio: [],
  deep_scene_options: {},
  deep_memory_options:[],
  deep_memory_llm_list:{},
  deep_memory_date_options:[],
  deep_memory_recond_list:{},
  deep_memory_sub_scene_options:[],
  deep_memory_trend:{},
  deep_memory_data:{},
  deep_memory_data_cread:{},
  deep_memory_data_cread_old:{},
  deep_memory_circle_chart:{},
  deep_uobject:[],
  deep_uobject_trend:{},
  memory_date:{},
  memory_version:{},
  memory_device:{},
  memory_device_second:{},
  memory_scene:{},
  memory_type:{},
  memory_date_version:{},
  memory_date_version_new:{},
  memory_date_version_device:{},
  memory_level:{},
  memory_scene_second:{},
  memory_module_all:{},
  memory_object_memory_report:{},
  memory_object_memory_trend:{},
  memory_funtion_trend:{},
  memory_funtion_id:{},
  memory_module_id:{},
  memory_funtion_trend_draw:{},
  memory_list:{},
  memory_list_data:{},
  memory_stack:{},
  memory_sub_stack:{},
  memory_all_stack:{},
  memory_appoint_stack:{},
  memory_appoint_old_left_stack:{},
  memory_appoint_old_right_stack:{},
  memory_all_stack_old:{},
  memory_sub_stack_old:{},
  memory_stack_old:{},
  memory_module_list:{},
  memory_function_list_all:{},
  memory_function_appoint:{},
  memory_function_appoint_old:{},
  memory_module_list_second:{},
  memory_module_list_appoint:{},
  memory_module_list_appoint_old:{},
  memory_module_trend:{},
  memory_module_sub_trend:{},
  deep_deepMemreport_data:{},
  deep_memory_download:{},
  deep_memory_scene_options:[],
  deep_memory_report:{},
  deep_unity_memory_report:{},
  deep_unity_memory_list:{},
  deep_scene_port: [],
  sgame_skin_list:[],
  avg_data: {},
  skin_management: [],
  sgame_skin_option:[],
  sgame_skin_data:[],
  skin_pkg: [],
  skin_date: [],
  skin_line_viewt: [],
  update_skin_line_view: {},
  test_case: {},
  test_case_list: [],
  case_control: "",
  simple_date_options:[],
  light_date_options:[],
  android_app_date_options:[],
  light_date_contrast_options:[],
  android_app_date_contrast_options:[],
  light_trend:{},
  android_app_file_trend:{},
  light_functions:{},
  light_url:'',
  android_app_filename:{},
  android_app_url:'',
  light_device_options:[],
  android_app_device_options:[],
  android_app_zip:{},
  light_scene_options:[],
  android_app_scene_options:[],
  light_resour_cost_options:{},
  android_app_file_compare:{},
  light_jank_cost_options:{},
  light_method_cost_options:{},
  light_log_options:[],
  android_app_log_options:[],
  light_subtype_options:[],
  android_app_subtype_options:[],
  abd_date_options:[],
  pkg_resource_date:[],
  pkg_resource_device:[],
  pkg_resource_scene:[],
  pkg_type_list:{},
  pkg_type_rate:{},
  pkg_asset_stack:{},
  pkg_asset_type:[],
  pkg_struct_stack:[],
  speedm_memory_list:[],
  speedm_memory_config:{},
  mem_summary_list:{},
  mem_summary_trend:{},
  mem_summary_trend_ios:{},
  mem_date_versions:[],
  mem_summary_list_v1:[],
  resource_dates:[],
  resource_car_list:[],
  resource_load_list:[],
  resource_skin_list:[],
  resource_overall:{},
  resource_average_data:[],
  resource_average_chart:[],
  resource_history:{},
  resource_average_chart_avg:{},
  resource_scan_type_list:[],
  resource_car_data:{},
  resource_records:[],
  resource_versions:[],
  resource_devices:[],
  resource_scenes:[],
  resource_id:{},
  speedm_memory_scenes:[],
  speedm_memory_records:[],
  speedm_memory_filename_list:[],
  speedm_memory_source_list:[],
  speedm_memory_source_file_list:{},
  speedm_mod_summary:{},
  speedm_mod_summary_v1:[],
  speedm_memory_res_summary:{},
  speedm_mod_list:{},
  speedm_mod_res_list:{},
  speedm_memory_res_trend:{},
  speedm_summary_list:{},
  speedm_mod_trend:{},
  speedm_memory_summary:{},
  speedm_memory_trend:{},
  pkg_map_struct_stack:[],
  pkg_map_struct_stack_list:[],
  pkg_map_struct_stack_option:[],
  pkg_asset_stack_find:[],
  pkg_resource_sum:'',
  pkg_resource_trend:{},
  pkg_asset_trend:{},
  pkg_struct_trend:{},
  pkg_abnorma_trend:{},
  pkg_map_struct_trend:{},
  deep_cpu_labels:{},
  deep_cpu_usage_trend:{},
  deep_cpu_labels_old:{},
  deep_cpu_perf_trend:{},
  deep_cpu_custom_trend:{},
  deep_cpu_versions:{},
  deep_cpu_func_trend:{},
  deep_cpu_config:{},
  deep_cpu_config_so_list:{},
  deep_cpu_function_cos:{},
  deep_cpu_trend_node:[],
  deep_cpu_stack:{},
  deep_cpu_stack_merge:[],
  deep_cpu_stack_find:[],
  deep_frame_problem:{},
  deep_avg_stack:{},
  token_library_list:[],
  deep_cpu_stack_creat:{},
  deep_cpu_detail:{},
  deep_cpu_thread_by_frame:{},
  deep_caton_list:[],
  deep_cpu_stack_creat_old:{},
  deep_cpu_function_model:{},
  deep_cpu_versions_old:{},
  deep_cpu_put_detail:{},
  deep_simple_put_detail:{},
  deep_cpu_put_check:{},
  deep_cpu_function:{},
  deep_cpu_usage_list:[],
  deep_cpu_usage_list_qq:{},
  deep_cpu_usage_list_moudule_qq:{},
  deep_cpu_report:{},
  deep_func_list:{},
  deep_cpu_function_overview:[],
  deep_cpu_thread_list:{},
  deep_cpu_custom_data:{},
  deep_cpu_by_frame:{},
  deep_fps_inside_trend:{},
  deep_cpu_threads:{},
  deep_flame_url:{},
  deep_cpu_trend:{},
  deep_cpu_thread_trend:{},
  deep_cpu_so_trend:{},
  deep_cpu_module_trend:{},
  pkg_type_list_old:{},
  pkg_type_table:{},
  pkg_resource_list:[],
  pkg_resource_report:{},
  pkg_resource_list_old:[],
  pkg_resource_list_thread_old:[],
  smoke_by_report:{},
  
  light_smoke_scene:[],
  light_smoke_version:[],
  light_common_key:{},
  light_common_url:{},
  light_smoke_devices:[],
  light_smoke_tod_devices:[],
  light_smoke_list:{},
  abd_device_options:[],
  simple_type_options:[],
  simple_process_options:{},
  simple_thread_options:{},
  simple_log:{},
  simple_so_options:{},
  simple_label_options:[],
  cpu_deivce_options:{},
  cpu_trend:{},
  cpu_scene_options:{},
  simple_url:'',
  simple_device_options:[],
  simple_report_options:[],
  simple_version_options:[],
  simple_version_options_old:[],
  simple_trend_params:{},
  simple_total_params:{},
  simple_scene_options:[],
  simple_subtype_options:[],
  abd_scene_options:[],
  abd_subtype_options:[],
  abd_list:[],
  abd_date_single:[],
  abd_compare:{},
  abd_process_compare:{},
  abd_type:{},
  light_resource:{},
  android_app_file_data:{},
  light_jank:{},
  light_method:{},
  abd_sum:{},
  abd_log:{},
  abd_url:'',
  abd_Process:{},
  memory_resouce_speed_options:{},
  memory_resouce_vehice:{},
  simple_data:{},
  simple_by_data:{},
  simple_task_options:[],
  simple_table:{},
  android_offline_date:[],
  perfetto_options:{},
  perfetto_type_options:{},
  xcode_type_options:{},
  xcode_date_options:{},
  xcode_device_options:{},
  xcode_level_options:{},
  xcode_scene_options:{},
  xcode_dimens_options:[],
  perfetto_settings:{},
  performance_svg_log:[],
  performance_ds_log:[],
  performance_svg_log_data:{},
  performance_ds_log_data:{},
  perfetto_options_old:{},
  perfetto_old_date:{},
  perfetto_down_stack:{},
  perfetto_device_options:{},
  perfetto_device_options_trend:{},
  perfetto_device_options_important:{},
  perfetto_level_options:{},
  perfetto_Stack:{},
  xcode_Stack:{},
  perfetto_Stack_search:{},
  perfetto_Stack_search_v2:{},
  perfetto_Stack_search_so:{},
  perfetto_Stack_search_functions:{},
  perfetto_level_options_important:{},
  perfetto_scene_options:{},
  perfetto_native_trend:{},
  xcode_native_trend:{},
  perfetto_native_func_trend:{},
  xcode_native_func_trend:{},
  perfetto_so_func_trend:{},
  xcode_so_func_trend:{},
  perfetto_native_module:{},
  perfetto_so_list:[],
  perfetto_module_trend:{},
  perfetto_module_list:{},
  xcode_so_list:[],
  perfetto_native_all:[],
  xcode_native_all:[],
  xcode_native_module:{},
  perfetto_so_all:[],
  xcode_so_all:[],
  object_func_all:{},
  perfetto_report:{},
  xcode_report:{},
  android_offline_date_old:[],
  android_offline_device:[],
  android_offline_scenes:[],
  android_offline_subtypes:[],
  android_offline_list:[],
  android_offline_old_list:[],
  android_offline_thread_old_list:[],
  deep_cpu_func_report:{},
  android_thread_options:[],
  android_course_options:[],
  android_thread_compare:[],
  android_course_compare:[],
  android_course_trend:{},
  android_offline_zip:{},
  android_offline_url:'',
  android_thread_trend:{},
  android_course_process_list:{},
  android_thread_process_list:{},
};

export const PerformanceModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
